import { ResponseInterface } from "../interfaces";
import { HolidayDTO } from "../interfaces/Dtos/HolidayDTO";
import api from "./api";

const baseURLAPI = process.env.REACT_APP_API_HOST;

export const getHolidays = async (): Promise<
  ResponseInterface<HolidayDTO[]>
> => {
  const uri = `${baseURLAPI}/Calendar/Holidays`;

  try {
    const response = await api.get(uri);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {}

  return {
    message: "",
    didError: true,
    errorMessage: "Hubo un error obteniendo los dias feriados.",
    model: null,
  };
};
